import {Paragraph} from 'evergreen-ui';
import React, {FunctionComponent, memo} from 'react';
import {Referral, ServiceType} from 'referral/domain/types';

type ServiceTypeRendererProps = {
    referral: Partial<Referral>;
    textEllipsis?: boolean;
}
export const serviceTypeMapping = {
    [ServiceType.ABA_Parent_Training]: 'ABA Parent Training',
    [ServiceType.ABA_Services_Severe_Behavior]: 'ABA Services Severe Behavior',
    [ServiceType.ThreeTierOrParentTraining]: '3-Tier ABA OR ABA Parent Training',
    [ServiceType.ThreeTierOrParentLed]: '3-Tier ABA OR Parent Led ABA',
    [ServiceType.Coaching]: 'Coaching',
    [ServiceType.Group_ABA]: 'Group ABA',
    [ServiceType.PLAY_Project]: 'PLAY Project',
    [ServiceType.Parent_Led_ABA]: 'Parent Led ABA',
    [ServiceType.Social_Skills_Group]: 'Social Skills Group',
    [ServiceType.Traditional_ABA]: '3-Tier ABA',
    [ServiceType.Chat]: 'Chat',
    [ServiceType.Connect]: 'Connect',
    [ServiceType.RUBI]: 'RUBI',
    [ServiceType.Calibrate]: 'Calibrate ABA',
    [ServiceType.Compass_Behavioral]: 'Compass-Behavioral',
    [ServiceType.Compass_Psychotherapy]: 'Compass Psychotherapy',
    [ServiceType.Psychotherapy]: 'Psychotherapy',
} as const;

const serviceTypeMappingFunc =  (referral: Partial<Referral>, st: ServiceType) => {
   return  serviceTypeMapping[st];
}

export const ServiceTypeRenderer: FunctionComponent<ServiceTypeRendererProps> = memo(({referral, textEllipsis = true}: ServiceTypeRendererProps) => {
    if (!!referral.serviceTypes && Array.isArray(referral.serviceTypes) && referral.serviceTypes.length > 0) {
        return <>{referral.serviceTypes.map((st, idx) => <Paragraph
            className="portal-ev-tr-td"
            overflow={"hidden"}
            whiteSpace={textEllipsis ? "nowrap" : "normal"}
            textOverflow={textEllipsis ? "ellipsis" : "normal"}
            size={500} key={idx}>{serviceTypeMappingFunc(referral, st)}</Paragraph>)}</>;
    } else {
        return 'None';
    }
});
